<template>
  <ul class="menu-nav">
    <router-link
      to="/entities"
      v-slot="{ href, navigate, isActive, isExactActive }"
      custom
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <img class="menu-icon" :src="headerIcon('empresas')" alt />
          <span class="menu-text">Entidades Jurídicas</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/structure"
      v-slot="{ href, navigate, isActive, isExactActive }"
      custom
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <img class="menu-icon" :src="headerIcon('estructura')" alt />
          <span class="menu-text">Estructura</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/borme"
      v-slot="{ href, navigate, isActive, isExactActive }"
      custom
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <img class="menu-icon" :src="headerIcon('borme')" alt />
          <span class="menu-text">Borme</span>
        </a>
      </li>
    </router-link>

    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-bind:class="{ 'menu-item-open': hasActiveChildren('/lists/lists') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <img class="menu-icon" :src="headerIcon('listas')" alt />
        <span class="menu-text">Listas</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Listas</span>
            </span>
          </li>

          <!-- cargos -->
          <router-link
            to="/lists/cargos"
            v-slot="{ href, navigate, isActive, isExactActive }"
            custom
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Cargos</span>
              </a>
            </li>
          </router-link>

          <!-- provincias -->
          <!-- <router-link
            to="/lists/provincias"
            v-slot="{ href, navigate, isActive, isExactActive }"
            custom
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Provincias</span>
              </a>
            </li>
          </router-link>-->

          <!-- Áreas de cargo -->
          <router-link
            to="/lists/areas-cargos"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Áreas cargos</span>
              </a>
            </li>
          </router-link>

          <!-- Flotas -->
          <router-link
            to="/lists/flotas"
            v-slot="{ href, navigate, isActive, isExactActive }"
            custom
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Flotas</span>
              </a>
            </li>
          </router-link>

          <!-- Fuente alta -->
          <router-link
            to="/lists/fuente-alta"
            v-slot="{ href, navigate, isActive, isExactActive }"
            custom
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Fuente alta</span>
              </a>
            </li>
          </router-link>

          <!-- Fuente baja -->
          <router-link
            to="/lists/fuente-baja"
            v-slot="{ href, navigate, isActive, isExactActive }"
            custom
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Fuente baja</span>
              </a>
            </li>
          </router-link>

          <!-- Fuente modificación -->
          <!-- <router-link
            to="/lists/fuente-modificacion"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Fuente modificación</span>
              </a>
            </li>
          </router-link>-->

          <!--  Formas jurídicas -->
          <!-- <router-link
            to="/lists/formas-juridicas"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">Formas jurídicas</span>
              </a>
            </li>
          </router-link> -->
        </ul>
      </div>
    </li>

    <!-- <router-link to="/users" v-slot="{ href, navigate, isActive, isExactActive }" custom>
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <img class="menu-icon" :src="headerIcon('usuarios')" alt />
          <span class="menu-text">Usuarios</span>
        </a>
      </li>
    </router-link>-->
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "KTMenu",
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    headerIcon(name) {
      return process.env.BASE_URL + this.layoutConfig(`self.menu.icon.${name}`);
    }
  }
};
</script>
